import * as React from "react";
import { Link } from "gatsby-link";

import BlueArrowRightIcon from "./icons/right-arrow-icon.png";

type SectionTwoButtonsProps = {
  icons: string[];
  texts: React.ReactNode[];
  buttonLinks: string[];
  buttonAltTexts: string[];
  buttonClassName?: string;
  className?: string;
};

const SectionTwoButtons: React.FC<SectionTwoButtonsProps> = ({
  icons,
  texts,
  buttonLinks,
  buttonAltTexts,
  buttonClassName,
  className,
}) => (
  <div className={`container section-two-buttons ${className || ""}`}>
    <div className="row lg_mt-5 mt-4-5 justify-between">
      {texts.map((text, index) => (
        <div
          key={buttonLinks[index] || `section-two-button-${index}`}
          className={`columns border-radius-24-2 ${
            index === 0 ? "large-5 small-12 lg:mr-1" : "large-6 small-12 mt-1 lg_mt-0"
          }`}
        >
          <Link
            className={`bg-royal-blue primary-btn-2 primary-btn color-white ${buttonClassName || ""}`}
            to={buttonLinks[index] || "/"}
          >
            <div className="m-auto sm:block">
              <img
                src={icons[index]}
                loading="eager"
                width={100}
                height={100}
                alt={buttonAltTexts[index] || ""}
              />
            </div>{" "}
            <div className="w-full justify-between flex my-auto">
              <p className="mb-0 text-[28px] QuireSanProSemiBold leading-[normal]">{text}</p>{" "}
              <img
                src={BlueArrowRightIcon}
                width={44}
                height={44}
                className="blue-arrow-right-icon mr-1 m-auto"
                alt={"Right arrow icon"}
              />
            </div>
          </Link>
        </div>
      ))}
    </div>
  </div>
);

export default SectionTwoButtons;
